import { render, staticRenderFns } from "./admin-paginas.vue?vue&type=template&id=4c89be58&"
import script from "./admin-paginas.vue?vue&type=script&lang=js&"
export * from "./admin-paginas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports